export default '5.17.2';